import { Pipe, PipeTransform } from '@angular/core'
import { StateColorMapping } from '../models/ticket.model'

@Pipe({ name: 'stateColor' })
export class StateColor implements PipeTransform {
  transform(value: string): string {
    return StateColorMapping[value] ?? ''
  }
}
